


// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const Contact = () => {
//   const [users, setUsers] = useState([]);
//   const [editUser, setEditUser] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);
//   const navigate = useNavigate();

//   const fetchUsers = () => {
//     axios.get('/api/v1/admin/users', { withCredentials: true })
//       .then(res => {
//         // Filter users with isRole === 2 and sort by createdAt in descending order
//         const filteredUsers = res.data.filter(user => user.isRole === 2);
//         const sortedUsers = filteredUsers.sort((a, b) => 
//           new Date(b.createdAt) - new Date(a.createdAt)
//         );
//         setUsers(sortedUsers);
//       })
        
//         // setUsers(res.data.filter(user => user.isRole === 2)))
//       .catch(err => console.error(err));
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const formatDate = (dateString) => {
//     if (!dateString) return 'Never';
//     try {
//       return new Date(dateString).toLocaleString('en-GB', {
//         day: '2-digit',
//         month: 'short',
//         year: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//       });
//     } catch (e) {
//       return 'Invalid date';
//     }
//   };

//   const handleDelete = async (userId) => {
//     if (!window.confirm('Are you sure you want to delete this user?')) return;

//     try {
//       await axios.delete(`/api/v1/admin/users/${userId}`, {
//         withCredentials: true
//       });
//       fetchUsers();
//     } catch (err) {
//       console.error('Delete error:', err);
//       alert('Failed to delete user');
//     }
//   };

//   const handleEdit = (user) => {
//     setEditUser(user);
//     setModalOpen(true);
//   };

//   const handleSaveEdit = async () => {
//     try {
//       await axios.put(`/api/v1/admin/users/${editUser._id}`, editUser, {
//         withCredentials: true
//       });
//       fetchUsers();
//       setModalOpen(false);
//     } catch (err) {
//       console.error('Edit error:', err);
//       alert('Failed to update user');
//     }
//   };

//   return (
//     // <div className="flex-1 p-4 md:p-8 overflow-x-auto">
//     <div className="flex-1 flex flex-col p-4 md:p-6">
//       <h2 className="text-xl md:text-2xl font-semibold mb-4">Contacts</h2>
//       {/* <div className="bg-white p-4 md:p-6 rounded-xl shadow"> */}
//       <div className="bg-white rounded-xl shadow flex-1 flex flex-col">
//         {/* <div className="block md:hidden"> */}
//             <div className="md:hidden flex-1 overflow-y-auto p-2">
//           {/* Mobile view - cards */}
//           {users.map(user => (
//             <div key={user._id} className="border-b p-4 mb-4 last:mb-0">
//               <div className="flex justify-between items-start">
//                 <div>
//                   <p className="font-medium">{user.username}</p>
//                   <p className="text-gray-600 text-sm">{user.mobileNumber}</p>
//                 </div>
//                 <div className="flex space-x-2">
//                   <button 
//                     onClick={() => navigate(`/admin-dashboard/users/${user._id}`)} 
//                     className="text-blue-600 text-sm"
//                   >
//                     👁
//                   </button>
//                   <button 
//                     onClick={() => handleEdit(user)} 
//                     className="text-yellow-600 text-sm"
//                   >
//                     ✏
//                   </button>
//                   {user.isRole === 1 ? (
//                     <button className="text-gray-400 text-sm cursor-not-allowed" disabled>
//                       🗑
//                     </button>
//                   ) : (
//                     <button 
//                       onClick={() => handleDelete(user._id)} 
//                       className="text-red-600 text-sm"
//                     >
//                       🗑
//                     </button>
//                   )}
//                 </div>
//               </div>
//               <div className="mt-2 text-sm text-gray-500">
//                 <p>Created: {new Date(user.createdAt).toLocaleDateString('en-GB', {
//                   day: '2-digit',
//                   month: 'short',
//                   year: 'numeric'
//                 }).replace(/ /g, '-')}</p>
//                 <p>Last Active: {formatDate(user.lastActive)}</p>
//               </div>
//             </div>
//           ))}
//         </div>
        
//         {/* <div className="hidden md:block"> */}
//           {/* Desktop view - table */}
//           {/* <table className="w-full text-left border-collapse">
//             <thead>
//               <tr className="text-gray-700 border-b">
//                 <th className="py-2 px-4">Name</th>
//                 <th className="py-2 px-4">Mobile Number</th>
//                 <th className="py-2 px-4">Created At</th>
//                 <th className="py-2 px-4">Last Active</th>
//                 <th className="py-2 px-4">Actions</th>
//               </tr>
//             </thead>
//             <tbody> */}
//             <div className="hidden md:block flex-1 overflow-y-auto">
//           <div className="min-w-[600px] p-4">
//             <table className="w-full border-collapse">
//               <thead className="sticky top-0 bg-white z-10 shadow-sm">
//                 <tr className="text-gray-700">
//                   <th className="py-3 px-4 text-left">Name</th>
//                   <th className="py-3 px-4 text-left">Mobile Number</th>
//                   <th className="py-3 px-4 text-left">Created At</th>
//                   <th className="py-3 px-4 text-left">Last Active</th>
//                   <th className="py-3 px-4 text-left">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//               {users.map(user => (
//                 <tr key={user._id} className="border-b hover:bg-gray-50">
//                   <td className="py-2 px-4">{user.username}</td>
//                   <td className="py-2 px-4">{user.mobileNumber}</td>
//                   <td className="py-2 px-4">
//                     {new Date(user.createdAt).toLocaleDateString('en-GB', {
//                       day: '2-digit',
//                       month: 'short',
//                       year: 'numeric'
//                     }).replace(/ /g, '-')}
//                   </td>
//                   <td className="py-2 px-4">{formatDate(user.lastActive)}</td>
//                   <td className="py-2 px-4 space-x-2">
//                     <button 
//                       onClick={() => navigate(`/admin-dashboard/users/${user._id}`)} 
//                       className="text-blue-600 hover:text-blue-800"
//                     >
//                       👁 View
//                     </button>
//                     <button 
//                       onClick={() => handleEdit(user)} 
//                       className="text-yellow-600 hover:text-yellow-800"
//                     >
//                       ✏ Edit
//                     </button>
//                     {user.isRole === 1 ? (
//                       <button 
//                         className="text-gray-400 cursor-not-allowed" 
//                         disabled 
//                         title="Admin user cannot be deleted"
//                       >
//                         🗑 Delete
//                       </button>
//                     ) : (
//                       <button 
//                         onClick={() => handleDelete(user._id)} 
//                         className="text-red-600 hover:text-red-800"
//                       >
//                         🗑 Delete
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//       </div>

//       {/* Edit User Modal */}
//       {modalOpen && (
//         <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 p-4">
//           <div className="bg-white p-4 md:p-6 rounded-xl shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
//             <h3 className="text-lg md:text-xl font-semibold mb-4">Edit User</h3>
//             <input
//               type="text"
//               value={editUser.username}
//               onChange={(e) => setEditUser({ ...editUser, username: e.target.value })}
//               placeholder="Name"
//               className="mb-3 p-2 border border-gray-300 rounded w-full text-sm md:text-base"
//             />
//             <input
//               type="text"
//               value={editUser.mobileNumber}
//               onChange={(e) => setEditUser({ ...editUser, mobileNumber: e.target.value })}
//               placeholder="Mobile"
//               className="mb-3 p-2 border border-gray-300 rounded w-full text-sm md:text-base"
//             />
//             <input
//               type="text"
//               value={editUser.gender}
//               onChange={(e) => setEditUser({ ...editUser, gender: e.target.value })}
//               placeholder="Gender"
//               className="mb-3 p-2 border border-gray-300 rounded w-full text-sm md:text-base"
//             />
//             <input
//               type="text"
//               value={editUser.status}
//               onChange={(e) => setEditUser({ ...editUser, status: e.target.value })}
//               placeholder="Status"
//               className="mb-3 p-2 border border-gray-300 rounded w-full text-sm md:text-base"
//             />
//             <input
//               type="number"
//               value={editUser.isRole}
//               onChange={(e) => setEditUser({ ...editUser, isRole: parseInt(e.target.value) })}
//               placeholder="Role (1 for Admin, 2 for User)"
//               className="mb-4 p-2 border border-gray-300 rounded w-full text-sm md:text-base"
//             />

//             <div className="flex justify-between">
//               <button 
//                 onClick={() => setModalOpen(false)} 
//                 className="text-gray-600 hover:text-gray-800 text-sm md:text-base"
//               >
//                 Cancel
//               </button>
//               <button 
//                 onClick={handleSaveEdit} 
//                 className="bg-blue-600 text-white px-3 py-1 md:px-4 md:py-2 rounded text-sm md:text-base"
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Contact;



import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Contact = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [editUser, setEditUser] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [itemsPerPage] = useState(10);
  const navigate = useNavigate();

  const fetchUsers = () => {
    axios.get('/api/v1/admin/users', { withCredentials: true })
      .then(res => {
        // Filter users with isRole === 2 and sort by createdAt in descending order
        const filteredUsers = res.data.filter(user => user.isRole === 2);
        const sortedUsers = filteredUsers.sort((a, b) => 
          new Date(b.createdAt) - new Date(a.createdAt)
        );
        setUsers(sortedUsers);
        setFilteredUsers(sortedUsers);
      })
      .catch(err => console.error(err));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    // Filter users based on search term
    if (searchTerm.trim() === '') {
      setFilteredUsers(users);
      setCurrentPage(1);
    } else {
      const filtered = users.filter(user => 
        user.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.mobileNumber.includes(searchTerm)
      );
      setFilteredUsers(filtered);
      setCurrentPage(1);
    }
  }, [searchTerm, users]);

  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    try {
      return new Date(dateString).toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch (e) {
      return 'Invalid date';
    }
  };

  const handleDelete = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;

    try {
      await axios.delete(`/api/v1/admin/users/${userId}`, {
        withCredentials: true
      });
      fetchUsers();
    } catch (err) {
      console.error('Delete error:', err);
      alert('Failed to delete user');
    }
  };

  const handleEdit = (user) => {
    setEditUser(user);
    setModalOpen(true);
  };

  const handleSaveEdit = async () => {
    try {
      await axios.put(`/api/v1/admin/users/${editUser._id}`, editUser, {
        withCredentials: true
      });
      fetchUsers();
      setModalOpen(false);
    } catch (err) {
      console.error('Edit error:', err);
      alert('Failed to update user');
    }
  };

  // Get current users for pagination
  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const renderPagination = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const leftOffset = Math.floor(maxVisiblePages / 2);
      let startPage = currentPage - leftOffset;
      let endPage = currentPage + leftOffset;
      
      if (startPage < 1) {
        startPage = 1;
        endPage = maxVisiblePages;
      } else if (endPage > totalPages) {
        endPage = totalPages;
        startPage = totalPages - maxVisiblePages + 1;
      }
      
      if (startPage > 1) {
        pageNumbers.push(1);
        if (startPage > 2) {
          pageNumbers.push('...');
        }
      }
      
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
      
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pageNumbers.push('...');
        }
        pageNumbers.push(totalPages);
      }
    }

    return (
      <div className="flex justify-center items-center mt-4 flex-wrap">
        <button
          onClick={() => paginate(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className={`mx-1 px-3 py-1 rounded ${currentPage === 1 ? 'text-gray-400 cursor-not-allowed' : 'text-blue-600 hover:bg-blue-50'}`}
        >
          &laquo;
        </button>
        
        {pageNumbers.map((number, index) => (
          number === '...' ? (
            <span key={`ellipsis-${index}`} className="mx-1 px-2 py-1">...</span>
          ) : (
            <button
              key={number}
              onClick={() => paginate(number)}
              className={`mx-1 px-3 py-1 rounded ${currentPage === number ? 'bg-blue-600 text-white' : 'text-blue-600 hover:bg-blue-50'}`}
            >
              {number}
            </button>
          )
        ))}
        
        <button
          onClick={() => paginate(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className={`mx-1 px-3 py-1 rounded ${currentPage === totalPages ? 'text-gray-400 cursor-not-allowed' : 'text-blue-600 hover:bg-blue-50'}`}
        >
          &raquo;
        </button>
      </div>
    );
  };

  return (
    <div className="flex-1 flex flex-col p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
        <h2 className="text-xl md:text-2xl font-semibold mb-2 md:mb-0">Contacts</h2>
        <div className="relative w-full md:w-64">
          <input
            type="text"
            placeholder="Search by name or mobile..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full p-2 pl-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <svg
            className="absolute left-2 top-3 h-4 w-4 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            ></path>
          </svg>
        </div>
      </div>
      
      <div className="bg-white rounded-xl shadow flex-1 flex flex-col">
        <div className="md:hidden flex-1 overflow-y-auto p-2">
          {/* Mobile view - cards */}
          {currentUsers.length > 0 ? (
            currentUsers.map(user => (
              <div key={user._id} className="border-b p-4 mb-4 last:mb-0">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-medium">{user.username}</p>
                    <p className="text-gray-600 text-sm">{user.mobileNumber}</p>
                  </div>
                  <div className="flex space-x-2">
                    <button 
                      onClick={() => navigate(`/admin-dashboard/users/${user._id}`)} 
                      className="text-blue-600 text-sm"
                    >
                      👁
                    </button>
                    <button 
                      onClick={() => handleEdit(user)} 
                      className="text-yellow-600 text-sm"
                    >
                      ✏
                    </button>
                    {user.isRole === 1 ? (
                      <button className="text-gray-400 text-sm cursor-not-allowed" disabled>
                        🗑
                      </button>
                    ) : (
                      <button 
                        onClick={() => handleDelete(user._id)} 
                        className="text-red-600 text-sm"
                      >
                        🗑
                      </button>
                    )}
                  </div>
                </div>
                <div className="mt-2 text-sm text-gray-500">
                  <p>Created: {new Date(user.createdAt).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                  }).replace(/ /g, '-')}</p>
                  <p>Last Active: {formatDate(user.lastActive)}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="p-4 text-center text-gray-500">
              No users found
            </div>
          )}
        </div>
        
        <div className="hidden md:block flex-1 overflow-y-auto">
          <div className="min-w-[600px] p-4">
            <table className="w-full border-collapse">
              <thead className="sticky top-0 bg-white z-10 shadow-sm">
                <tr className="text-gray-700">
                  <th className="py-3 px-4 text-left">Name</th>
                  <th className="py-3 px-4 text-left">Mobile Number</th>
                  <th className="py-3 px-4 text-left">Created At</th>
                  <th className="py-3 px-4 text-left">Last Active</th>
                  <th className="py-3 px-4 text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.length > 0 ? (
                  currentUsers.map(user => (
                    <tr key={user._id} className="border-b hover:bg-gray-50">
                      <td className="py-2 px-4">{user.username}</td>
                      <td className="py-2 px-4">{user.mobileNumber}</td>
                      <td className="py-2 px-4">
                        {new Date(user.createdAt).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric'
                        }).replace(/ /g, '-')}
                      </td>
                      <td className="py-2 px-4">{formatDate(user.lastActive)}</td>
                      <td className="py-2 px-4 space-x-2">
                        <button 
                          onClick={() => navigate(`/admin-dashboard/users/${user._id}`)} 
                          className="text-blue-600 hover:text-blue-800"
                        >
                          👁 View
                        </button>
                        <button 
                          onClick={() => handleEdit(user)} 
                          className="text-yellow-600 hover:text-yellow-800"
                        >
                          ✏ Edit
                        </button>
                        {user.isRole === 1 ? (
                          <button 
                            className="text-gray-400 cursor-not-allowed" 
                            disabled 
                            title="Admin user cannot be deleted"
                          >
                            🗑 Delete
                          </button>
                        ) : (
                          <button 
                            onClick={() => handleDelete(user._id)} 
                            className="text-red-600 hover:text-red-800"
                          >
                            🗑 Delete
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="py-4 text-center text-gray-500">
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        
        {filteredUsers.length > itemsPerPage && renderPagination()}
      </div>

      {/* Edit User Modal */}
      {modalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 p-4 z-50">
          <div className="bg-white p-4 md:p-6 rounded-xl shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg md:text-xl font-semibold mb-4">Edit User</h3>
            <input
              type="text"
              value={editUser.username}
              onChange={(e) => setEditUser({ ...editUser, username: e.target.value })}
              placeholder="Name"
              className="mb-3 p-2 border border-gray-300 rounded w-full text-sm md:text-base"
            />
            <input
              type="text"
              value={editUser.mobileNumber}
              onChange={(e) => setEditUser({ ...editUser, mobileNumber: e.target.value })}
              placeholder="Mobile"
              className="mb-3 p-2 border border-gray-300 rounded w-full text-sm md:text-base"
            />
            {/* <input
              type="text"
              value={editUser.gender}
              onChange={(e) => setEditUser({ ...editUser, gender: e.target.value })}
              placeholder="Gender"
              className="mb-3 p-2 border border-gray-300 rounded w-full text-sm md:text-base"
            />
            <input
              type="text"
              value={editUser.status}
              onChange={(e) => setEditUser({ ...editUser, status: e.target.value })}
              placeholder="Status"
              className="mb-3 p-2 border border-gray-300 rounded w-full text-sm md:text-base"
            />
            <input
              type="number"
              value={editUser.isRole}
              onChange={(e) => setEditUser({ ...editUser, isRole: parseInt(e.target.value) })}
              placeholder="Role (1 for Admin, 2 for User)"
              className="mb-4 p-2 border border-gray-300 rounded w-full text-sm md:text-base"
            /> */}

            <div className="flex justify-between">
              <button 
                onClick={() => setModalOpen(false)} 
                className="text-gray-600 hover:text-gray-800 text-sm md:text-base"
              >
                Cancel
              </button>
              <button 
                onClick={handleSaveEdit} 
                className="bg-blue-600 text-white px-3 py-1 md:px-4 md:py-2 rounded text-sm md:text-base"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;